import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import configData from './config.js'
import axios from './axios-auth'


Vue.config.productionTip = false
axios.defaults.baseURL = configData.baseURL

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

Vue.config.devtools = false


